<template>
  <div class="overflow-hidden v-card v-sheet theme--light mt-0">
    <!-- alert message -->
    <div>
      <!-- <v-alert :type="alert_type" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert> -->
    </div>
    <div>
      <HeaderComponent :headerTitle="headerText" />
    </div>
  
    <v-row justify="center">
      <v-dialog v-model="editPopup" persistent max-width="400px">
        <v-card class="v-card-100 pa-0">
          <v-card class="v-card-100 pa-0">
          <v-card-title class="py-3 d-flex">
            <span>{{ poptitle }}</span>
            <v-spacer></v-spacer>
            <v-icon @click="editPopup = false">mdi-close</v-icon>
          </v-card-title>
        </v-card>
          <v-card-text class="pb-0 pt-6">
            <v-text-field v-model="contact_number" label="Contact Number" variant = "outlined" oninput="this.value = this.value.replace(/[^0-9,]/g, '').slice(0,10)" v-if="action == 'update_contact'"/>
            <v-text-field v-model="entered_otp" label="Enter OTP" variant = "outlined" oninput="this.value = this.value.replace(/[^0-9,]/g, '')" v-if="action == 'otp_sended'" hide-details/>
            <div v-if="action == 'otp_sended'" class="pa-2 pt-1 mb-2" style="font-size: 13px;">Enter the OTP sent to the mobile number</div>
            <span class="progressbar" v-if="action == 'otp_sended'">00 : {{ formatTime(profiletimer) }} sec</span>
            <a href="#" @click="send_otp" :class="{ 'disabled-link': isResendDisabled }" v-if="action == 'otp_sended'"
              style="float:right;color:#2b81d6;">Resend OTP
            </a>
          </v-card-text>
          <v-card-actions center class="mt-4">
            <v-spacer></v-spacer>
            <v-btn variant = "outlined" color="primary" class="text-none" @click="editPopup = false">Cancel</v-btn>
            <v-btn color="primary" variant="flat" class="text-none" @click="send_otp" v-if="action == 'update_contact'" :disabled="contact_number.length != 10">Send OTP</v-btn>
            <v-btn color="primary" variant="flat" class="text-none" @click="verify_otp_submit" v-if="action == 'otp_sended'" :disabled="entered_otp.length < 4">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  
    <v-card style="height: 83vh !important; top:10px" >
      <v-card-text class="ml-10 pt-10">
        <v-row >
          <v-col cols="4" class="text-left">
            <span class="left_heading">Employee Name</span>
          </v-col>
          <v-col cols="4" class="text-left">
            <span class="left_value">{{ name }}</span>
          </v-col>
        </v-row>
        <v-row class="mt-8">
          <v-col cols="4" class="text-left">
            <span class="left_heading">E-mail ID</span>
          </v-col>
          <v-col cols="4" class="text-left">
            <span class="left_value">{{ email }}</span>
          </v-col>
        </v-row>
        <v-row class="mt-8">
          <v-col cols="4" class="text-left">
            <span class="left_heading">Employee ID</span>
          </v-col>
          <v-col cols="4" class="text-left">
            <span class="left_value">{{ employee_id }}</span>
          </v-col>
        </v-row>
        <v-row class="mt-8">
          <v-col cols="4" class="text-left">
            <span class="left_heading">Contact Number</span>
          </v-col>
          <v-col cols="4" class="text-left">
            <div v-if="primary_contact_number" class="mb-2">
              <span class="left_value">{{ primary_contact_number }}</span>
              <span><v-icon class="pencil_css" style="color: #1D88FB !important;" @click="edit_contact_number('contact_number')">mdi-pencil-outline</v-icon></span>
              <span><v-icon class="pencil_css" style="color: red !important;" @click="delete_contact_number('contact_number')">mdi-delete-outline</v-icon></span>
            </div>
            <v-btn class="addmore_css" variant = "outlined" v-if="!primary_contact_number" @click="addMoreContact('contact_number')">+Add Number</v-btn>
            <div v-if="alternate_contact_number" class="my-2">
              <span class="left_value">{{ alternate_contact_number }}</span>
              <span><v-icon class="pencil_css" style="color: #1D88FB !important;" @click="edit_contact_number('alternate_contact_number')">mdi-pencil-outline</v-icon></span>
              <span><v-icon class="pencil_css" style="color: red !important;" @click="delete_contact_number('alternate_contact_number')">mdi-delete-outline</v-icon></span>
            </div>
            <v-btn class="addmore_css" variant = "outlined" v-if="primary_contact_number && !alternate_contact_number" @click="addMoreContact('alternate_contact_number')">+ Alternate Number</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
  import HeaderComponent from "@/components/commoncomponents/HeaderComponent";
  export default {
    data() {
      return {
        headerText : 'Profile',
        alert : false,
        editPopup : false,
        poptitle : '',
        contact_number : '',
        contact_list : [],
        name : '',
        employee_id : '',
        email : '',
        action : '',
        entered_otp : '',
        profiletimer: 60,
        enter_otp: '',
        timerInterval: null,
        edit_number_type : '',
        primary_contact_number : '',
        alternate_contact_number : ''
      }
    },
    components:{
      HeaderComponent
    },
    created(){
      this.getProfileInfo();
    },
    computed:{
      isResendDisabled() {
        return this.profiletimer > 0;
      },
    },
    methods:{
      delete_contact_number(type){
        if(type == 'contact_number')
          this.primary_contact_number = ''
        else this.alternate_contact_number = ''
        this.action = 'delete_contact'
        this.edit_number_type = type
        this.update_contact_number()
      },
      edit_contact_number(type){
        this.editPopup = true
        this.poptitle = "Edit Contact"
        this.contact_number = type == 'contact_number' ? this.primary_contact_number : this.alternate_contact_number
        this.edit_number_type = type
        this.action = 'update_contact'
      },
      addMoreContact(type){
        this.editPopup = true
        this.poptitle = "Add Contact"
        this.contact_number = ''
        this.action = 'update_contact'
        this.edit_number_type = type
      },
      getProfileInfo(){
        const api = "/profile"
        this.$httpSecured
        .get(api)
        .then(response => {
          this.name = response.data.user.name
          this.employee_id = response.data.user.employee_id
          this.email = response.data.user.email
          this.primary_contact_number = response.data.user.contact_no
          this.alternate_contact_number = response.data.user.alternate_contact_no
        })
        .catch(error => {
          this.$toast.error(error.response.data.error)
          this.loading = false;
        });
      },
      send_otp(){
        const params = {
          "contact_number": this.contact_number
        }
        this.$httpSecured
        .get("/profile/send_otp",{ params})
        .then(response => {
          this.action = "otp_sended"
          this.startTimer();
          this.entered_otp = ''
          this.$toast.success(response.data.message)
        })
        .catch(error => {
          this.$toast.error(error.response.data.error)
          this.loading = false;
        });
      },
      formatTime(seconds) {
        const remainingSeconds = seconds % 120;
        return `${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
      }, 
  
      startTimer() {
        this.profiletimer = 60;
        this.timerInterval = setInterval(() => {
          if (this.profiletimer > 0) {
            this.profiletimer--;
          } else {
            clearInterval(this.timerInterval);
          }
        }, 1000);
      },
      verify_otp_submit(){
        const params = {
          "contact_number": this.contact_number,
          "otp": this.entered_otp
        }
        this.$httpSecured
        .put("/profile/verify_otp",params)
        .then(response => {
          // this.$toast.success(response.data.message)
          if(response.data.type == 'success'){
            this.update_contact_number();
          }
        })
        .catch(error => {
          this.$toast.error(error.response.data.message)
          this.profiletimer = 0
          this.loading = false;
        });
      },
      update_contact_number(){
        this.editPopup = false;
        const params = {
          'name' : this.name,
          'employee_id' : this.employee_id,
          'email' : this.email,
          'contact_no' : this.primary_contact_number,
          'alternate_contact_no' : this.alternate_contact_number
        }
        if(this.action != 'delete_contact')
          if(this.edit_number_type == 'contact_number')
            params.contact_no = this.contact_number
          else params.alternate_contact_no = this.contact_number
        
        this.$httpSecured
        .put("/profile",{ user : params})
        .then(response => {
          this.$toast.success(response.data.message)
          this.getProfileInfo();
        })
        .catch(error => {
          this.$toast.error(error.response.data.error)
          this.loading = false;
        });
      }
    }
  }
</script>
<style scoped>
  .left_heading{
    font-weight: 500;
    font-size: 16px;
    line-height : 16.94px;
    color:#000;
  }
  .left_value{
    font-weight: 400;
    font-size: 16px;
    line-height : 16.94px;
    color: #000;
  }
  .pencil_css{
    font-size: 23px;
    margin-left: 12px;
    margin-bottom: 6px;
    cursor: pointer;
  }
  .addmore_css{
    font-weight: 500;
    font-size: 16px;
    line-height : 16.94px;
    color:#0357D0;
    text-transform: none;
    padding : 0px 12px !important;
    border-radius: 6px !important;
  }
  .disabled-link {
    pointer-events: none;
    color: #aaa !important;
  }
</style>